/**
 * Extracts initials from a full name
 * @param fullName - The full name string
 * @returns A string with 1-2 uppercase initials
 * @throws Error if input is not a non-empty string
 */
export function getInitials(fullName: string): string {
  if (typeof fullName !== "string" || fullName.trim() === "") {
    throw new Error("Input must be a non-empty string");
  }

  const words: string[] = fullName.trim().split(/\s+/);

  if (words.length === 1) {
    return words[0][0].toUpperCase();
  }

  return (words[0][0] + words[1][0]).toUpperCase();
}


/** RFC 5322–style email validation (relaxed). */
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const isValidEmail = (value: string): boolean => {
  return EMAIL_REGEX.test(value.trim());
}
/** Flattens an HTML fragment to plain text (for one-line previews). */
export function stripHtml(html: string): string {
  return html
    .replace(/<[^>]+>/g, " ")
    .replace(/&nbsp;/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}
